import React from 'react';

export default function CustomOptionalIcon() {
  return (<span className="optional">省略可</span>);
}
